var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmallArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  fillRule: "evenodd",
  d: "M7.231 7.782.864 1.414 2.278 0l7.775 7.775-7.771 7.849L.86 14.217l6.371-6.435Z",
  clipRule: "evenodd"
})));
export default SvgSmallArrow;